import { lazy } from "react";
import WithSuspense from "../../components/Loaders/WithSuspense";
import { AppRoute } from "../types";
import { PRIVATE_PATHS } from "../constants";

const { CORE } = PRIVATE_PATHS;

const OnboardingSuccess = WithSuspense(lazy(() => import("../../pages/AccountSetup/OrganizationOnboarding/OnboardingSuccess")));
const EmployeeOnboarding = WithSuspense(lazy(() => import("../../pages/AccountSetup/EmployeeOnboarding")));
const UserProfile = WithSuspense(lazy(() => import("../../pages/HRMS/Employee/UserProfile/UserProfile")));
const ManageUsers = WithSuspense(lazy(() => import("../../pages/SuperAdmin/Overview/ManageUsers")));
const OrganizationSettings = WithSuspense(lazy(() => import("../../pages/Settings/OrganizationSettings")));
const Dashboard = WithSuspense(lazy(() => import("../../pages/HRMS/Employee/Dashboard/Dashboard")));
const HandBook = WithSuspense(lazy(() => import("../../pages/HRMS/Employee/HandBook/HandBook")));
const EmployeeProfile = WithSuspense(lazy(() => import("../../pages/HRMS/Employee/Profile/Profile")));
const Resignation = WithSuspense(lazy(() => import("../../pages/HRMS/Employee/Support/Resignation")));
const NotificationsPage = WithSuspense(lazy(() => import("pages/Notifications/Notifications")));

const ALL_ROLES = [
  "ORG_OWNER", "ORG_ADMIN", "HRM_ADMIN", "HRM_MANAGER", "HRM_EMPLOYEE",
  "PMO_ADMIN", "PMO_MANAGER", "PMO_USER", "CRM_ADMIN", "CRM_MANAGER", "CRM_USER", "EMPLOYEE",
];

export const CORE_ROUTES: AppRoute[] = [
  { path: "/:orgSlug/settings/users",   element: <ManageUsers />,        roles: ["ORG_OWNER", "ORG_ADMIN", "PMO_ADMIN", "HRM_ADMIN", "HRM_MANAGER", "CRM_ADMIN"] },
  { path: CORE.SETTINGS.ORGANIZATION,   element: <OrganizationSettings />, roles: ["ORG_OWNER", "ORG_ADMIN"] },
  { path: CORE.ONBOARDING_SUCCESS,       element: <OnboardingSuccess />,  roles: ALL_ROLES },
  { path: CORE.EMPLOYEE_ONBOARDING,      element: <EmployeeOnboarding />, roles: ALL_ROLES },
  { path: CORE.DASHBOARD,                element: <Dashboard />,          roles: ALL_ROLES },
  { path: CORE.MY_PROFILE,              element: <EmployeeProfile />,    roles: ALL_ROLES },
  { path: CORE.HANDBOOK,                element: <HandBook />,            roles: ALL_ROLES },
  { path: CORE.RESIGNATION,             element: <Resignation />,        roles: ALL_ROLES },
  { path: CORE.SETTINGS.USER_PROFILE,   element: <UserProfile />,        roles: ALL_ROLES },
  { path: CORE.NOTIFICATIONS,           element: <NotificationsPage />,  roles: ALL_ROLES },
];
